import isUndefined from 'lodash/isUndefined';

export default class PrefixedQueryBuilder {
  constructor() {
    this.reset();
  }

  add(key, value) {
    switch (key) {
      case 'where':
        this.where.push(value);
        break;
      case 'whereB':
        this.whereB.push(value);
        break;
      case 'limit':
        if (value === null) {
          delete this.limit;
        } else {
          this.limit = parseInt(value, 10);
        }
        break;
      case 'skip':
        if (value === null) {
          delete this.skip;
        } else {
          this.skip = parseInt(value, 10);
        }
        break;
      case 'populate':
        this.populate.push(value);
        break;
      case 'sort':
        Object.assign(this.sort, value);
        break;
      case 'custom':
        Object.assign(this.custom, value);
        break;
      case 'customB':
        Object.assign(this.custom.b, value);
        break;
      default:
        throw new Error(`Current QueryBuilder does not support "${key}"`);
    }
  }

  reset() {
    this.where = [];
    this.whereB = [];
    this.populate = [];
    this.sort = {};
    this.custom = {};
    this.custom.b = {};
    delete this.limit;
    delete this.skip;
  }

  build() {
    return Object.assign(
      { where: { AND: this.where } },
      { whereB: { AND: this.whereB } },
      { sort: this.sort },
      !isUndefined(this.limit) ? { limit: this.limit } : {},
      !isUndefined(this.skip) ? { skip: this.skip } : {},
      (
        this.populate.length
        ? { populate: Object.assign({}, ...this.populate) }
        : {}
      ),
      this.custom,
    );
  }

  compile() {
    return JSON.stringify(this.build());
  }
}
